<script lang="ts">
  import { setAddressAsDefault } from "../../lib/apiLoader/address";
  import BaseAddress from "./BaseAddress.svelte";
  import { selectedAddressStore, addressesStore, setMode } from "../../lib/stores/addresses";
  import Card from "../Address/AddressCard.svelte";
  import Button from "../Button.svelte";
  import SlideOverlay from "../SlideOverlay.svelte";
  import AddressSelector from "../Address/Selector.svelte";
  import { getCopy } from "../../lib/stores/copy";
  import { navigateTo } from "../../lib/routing";
  import { NavigationType } from "../../lib/stores/session";

  export let currentRoute;
  export let isLoading = false;

  const onNext = async () => {
    isLoading = true;
    if ($selectedAddressStore) {
      // TODO: Try catch to handle failures
      // TODO: we should probably show a loading view here
      // just be careful to not unload the map, just hide the view, I guess
      await setAddressAsDefault($selectedAddressStore.id);
      navigateTo(NavigationType.Next);
    }
    isLoading = false;
  };

  const onCloseClick = () => setMode("view");
  const onChangeAddressClick = () => setMode("select");

  $: copy = $getCopy("address") as Record<string, string>;
</script>

<!-- TODO: should be loading otherwise -->
{#if $selectedAddressStore}
  <BaseAddress
    {currentRoute}
    {onNext}
    selectedUserAddress={$selectedAddressStore}
    buttonCopy={copy.buttonText}
    isValid={true}
    {isLoading}>
    <svelte:fragment slot="content">
      <Card selectedAddress={$selectedAddressStore} />
      {#if $addressesStore.mode === "select"}
        <SlideOverlay onOverlayClick={onCloseClick} {onCloseClick}>
          <AddressSelector closeModal={onCloseClick} />
        </SlideOverlay>
      {/if}
    </svelte:fragment>
    <svelte:fragment slot="additional-action-buttons">
      <!-- TODO: what if it has a single address set? not much to choose... -->
      <Button on:click={onChangeAddressClick} secondary>
        {copy.changeAddressButtonText}
      </Button>
    </svelte:fragment>
  </BaseAddress>
{/if}
